import { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Telegram from '@twa-dev/sdk'

import Navbar from './components/Navbar'
import Home from './pages/home/Home'
import Mint from './pages/mint/Mint'
import MyNFTs from './pages/mynfts/MyNFTs'
import NFTGallery from './pages/nftgalary/NFTGallery'
import { WalletProvider } from './components/WalletContext'

function App() {
	useEffect(() => {
		Telegram.ready()
		Telegram.expand()
	}, [])

	return (
		<WalletProvider>
			<Router>
				<div className='App'>
					<Navbar />
					<Routes>
						<Route path='/' element={<Home />} />
						<Route path='/mint' element={<Mint />} />
						<Route path='/my-nfts' element={<MyNFTs />} />
						<Route path='/galery-nfts' element={<NFTGallery />} />
					</Routes>
				</div>
			</Router>
		</WalletProvider>
	)
}

export default App
